import { z } from "zod"
import cognitoPasswordRules from "@gap/utils/auth/cognitoPasswordRules"
import errorMap from "@gap/backend/util/validations/validation-error-map"

export const superRefinePassword = (value: string, context: z.RefinementCtx): void => {
   Object.entries(cognitoPasswordRules).some(([errorKey, validate]) => {
      const { success, errorMessage } = validate(value)
      if (!success) {
         context.addIssue({
            code: 'custom',
            message: errorMessage,
         })
      }
   })
}

export const refinePasswordsMatch: [(values: PasswordFieldPair) => boolean, { message: string, path: string[] }]
   = [({ password, passwordConfirm }) => password === passwordConfirm, { message: 'Passwords must match', path: ['passwordConfirm'] }]

export const PasswordConfirmSchema = z.object({
   password: z.string({ errorMap }).superRefine(superRefinePassword),
   passwordConfirm: z.string({ errorMap }),
}).refine(...refinePasswordsMatch)

interface PasswordFieldPair {
   password: string,
   passwordConfirm: string
}
